module.exports = __webpack_public_path__ + "img/Logo_iNoe_96px.f96a49dc.png";